import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { AiAgentsRoute, AiAgentsPathName } from '@/modules/ta/aiagent/aiagent.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${AiAgentsRoute.AIAGENT}`,
      name: AiAgentsPathName.AIAGENT,
      component: () => import(/* webpackChunkName: "aiagent-page" */ './pages/AiAgentsPage.vue'),
      props: true,
    },
  ],
  Module.AIAGENT
);
